import { memo } from 'react';
import { escape } from 'lodash';
import { ImageWithTextListContained } from '@quicktools/shared-components/components/landingPages/ImageWithTextListContained';
import MinimalFaq from '@quicktools/shared-components/components/landingPages/MinimalFaq';
import { ImageWithTextList } from '@quicktools/shared-components/components/landingPages/ImageWithTextList';
import { ImageWithText } from '@quicktools/shared-components/components/landingPages/ImageWithText';
import TabSection from '@quicktools/shared-components/components/landingPages/TabSection2';
import { Trans, useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import { IMG_WITH_TEXT_SIZES } from '@quicktools/shared-components/components/landingPages/constants';
import { TFunction } from 'i18next';
import {
  AD_COPY_GENERATOR_TOOL,
  FONT_GENERATOR_TOOL,
  MARKETING_SLOGAN_TOOL,
  SingleToolSimilar,
  SOCIAL_MEDIA_BIO_TOOL,
  ToolCategory,
} from '@quicktools/shared-components';

import analytics from '../../../services/analytics';

import image from './images';
import useStyles from './styles';

const getSteps = (noOfSteps: number, key: string, t: TFunction) => {
  return Array.from(Array(noOfSteps)).map((_, index) => ({
    title: (
      <Trans i18nKey={`${key}.${index}.title`} components={{ bold: <strong />, a: <a /> }} />
    ) as ReactNode,
    description: (
      <Trans i18nKey={`${key}.${index}.description`} components={{ bold: <strong />, a: <a /> }} />
    ) as ReactNode,
    alt: t(`${key}.${index}.imgAlt`),
  }));
};

const generateData = (texts: ReturnType<typeof getSteps>, img: string[]) => {
  return texts.map((obj: { title: ReactNode; description: ReactNode; alt: string }, i) => ({
    ...obj,
    src: img[i],
  }));
};

const IMAGES_WITH_TEXT = [
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/a2d83c72-c8fe-4d3b-bb0c-3c1a4a9e8ab4.png',
    srcSet:
      'https://pastatic.picsart.com/cms-pastatic/35f5d092-de60-479f-909e-aff48ee027e0.png 327w, https://pastatic.picsart.com/cms-pastatic/a2d83c72-c8fe-4d3b-bb0c-3c1a4a9e8ab4.png 648w',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/334967d8-5fdc-4f49-8159-9cefee6b4a76.png',
    srcSet:
      'https://pastatic.picsart.com/cms-pastatic/334967d8-5fdc-4f49-8159-9cefee6b4a76.png 327w, https://pastatic.picsart.com/cms-pastatic/ed15bd84-852a-4907-bf5a-8f13fba54dcb.png 648w',
  },
];

const STEPS_IMAGES = [
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/aed0c851-ee89-4b8c-b4c2-8b2a9bc26eea.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/1e0ce522-b00e-4bf4-8628-b5879e4a53b5.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/11af2b0e-cfad-4a7d-8339-3dbbe878793a.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/d014c717-fe99-4342-8b22-6047067e3593.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/cc904ab6-ac60-4b88-970a-450093661db3.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/ee2d228f-bb61-41da-a3c8-b4e79f114d96.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/80bb6d3f-af52-4d99-850c-b84bac638509.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/1c0a7583-d811-4a9c-b4c2-4f4b1deef1d5.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/bd778273-af47-4fd1-8826-9ed81c0a0101.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/6e7b40f2-4d32-4edb-a66c-b3ac1b1bde4a.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/a69d7039-6c1b-4d3c-9b10-29243222088c.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/06bce868-ce63-4191-a5b5-ca3b096d4362.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/a0c7de5a-4ec9-4628-8285-d0dc1c047852.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/d8864506-34cd-4d2a-accd-8c53168084c8.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/bf192bac-721b-4ce5-90e1-7b01ed314a42.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/ae8fe851-2801-4e0b-9336-6bdc2353cba0.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/e066b0f4-4a73-4e32-a6b3-717b599fa123.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/251e40a7-ae4f-439e-9dee-d94b1a8ec6ea.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/39128489-6ef0-4483-8de7-293480a2bf17.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/e425da54-9c5e-4cba-af53-1d4e77230dc8.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/9d59b9fd-c3a7-4a06-bd32-6e3c6e4829b6.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/dfc8b061-e5dc-428d-92e5-f80d5b2bce52.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/3b327b53-39c1-4a17-9c2b-8b0830a4d3c3.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/b419b254-6dcc-46bb-985a-8d7213372baa.png',
  },
  {
    src: 'https://pastatic.picsart.com/cms-pastatic/452d1da5-aaf6-4197-b8ec-6b3bb811bb13.png',
    mobileSrc: 'https://pastatic.picsart.com/cms-pastatic/18ccadee-49ee-475e-9e50-417574d39110.png',
  },
];

const TOOLS = [SOCIAL_MEDIA_BIO_TOOL, AD_COPY_GENERATOR_TOOL, MARKETING_SLOGAN_TOOL];

function Static() {
  const styles = useStyles();
  const { t } = useTranslation();

  const benefitsData = generateData(getSteps(3, 'benefitsBold.items', t), image.benefits);

  const imagesWithText = [0, 1].map((i) => ({
    title: t(`toolDetailsBold.${i}.title`),
    description: (
      <Trans
        i18nKey={`toolDetailsBold.${i}.description`}
        components={{ a: <a />, br: <br />, strong: <strong /> }}
      />
    ),
    ...IMAGES_WITH_TEXT[i],
    sizes: IMG_WITH_TEXT_SIZES,
  }));

  const faqItems = [0, 1, 2, 3, 4, 5, 6].map((i) => ({
    title: t(`faqMinimalBold.${i}.title`),
    description: (
      <Trans
        shouldUnescape={true}
        i18nKey={`faqMinimalBold.${i}.description`}
        components={{
          br: <br />,
          a: <a />,
        }}
        values={{ strongTag: escape('<strong>'), bTag: escape('<b>') }}
      />
    ),
  }));

  const tabItems = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => ({
    title: (
      <Trans i18nKey={`stepsBold.items.${i}.title`} components={{ bold: <strong />, a: <a /> }} />
    ),
    description: (
      <Trans
        i18nKey={`stepsBold.items.${i}.description`}
        components={{ bold: <strong />, a: <a /> }}
      />
    ),
    alt: t(`stepsBold.item.${i}.alt`),
    ...STEPS_IMAGES[i],
  }));

  return (
    <>
      <div className={styles.root}>
        <ImageWithTextList items={imagesWithText} />
        <TabSection title={t('stepsBold.title')} items={tabItems} />
        <ImageWithText
          alt={t('toolDetails2Bold.0.title')}
          title={t('toolDetails2Bold.0.title')}
          description={
            <Trans
              i18nKey={`toolDetails2Bold.0.description`}
              components={{ a: <a />, br: <br />, strong: <strong /> }}
            />
          }
          src="https://pastatic.picsart.com/cms-pastatic/c09a72f8-bd74-4959-b119-765e1bd0f593.png"
          srcSet="https://pastatic.picsart.com/cms-pastatic/c09a72f8-bd74-4959-b119-765e1bd0f593.png 327w, https://pastatic.picsart.com/cms-pastatic/03e7f37a-7c69-4d2d-baa0-d06c13b49000.png 648w"
          sizes={IMG_WITH_TEXT_SIZES}
        />
        <ImageWithTextListContained
          items={benefitsData}
          title={<Trans i18nKey={`benefitsBold.title`} components={{ strong: <strong /> }} />}
        />

        <MinimalFaq items={faqItems} />

        <SingleToolSimilar
          current={FONT_GENERATOR_TOOL}
          analytics={analytics}
          className={styles.similar}
          similar={TOOLS}
          category={ToolCategory.Text}
        />
      </div>
    </>
  );
}

export default memo(Static);
